"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAllProducts = exports.getProduct = exports.getUserInfo = exports.syncSubscriptionChanges = void 0;
const axios_1 = __importDefault(require("axios"));
const REVENUECAT_ENDPOINT_V1 = "https://api.revenuecat.com/v1/";
const REVENUECAT_ENDPOINT_V2 = "https://api.revenuecat.com/v2/";
const REVENUECAT_API_KEY = "strp_JdpQSXHOpOWvWoFuOkcplTQyNHt";
const REVENUECAT_API_KEY_V2 = "sk_mMRhyOUgrZvgbkbmDDlQcEeHhUsPp";
const REVENUECAT_PROJECT_ID = '32184e05';
const revenueCatNetworkV1 = axios_1.default.create({
    baseURL: REVENUECAT_ENDPOINT_V1,
    headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${REVENUECAT_API_KEY}`,
        'X-Platform': 'stripe',
    }
});
const revenueCatNetworkV2 = axios_1.default.create({
    baseURL: REVENUECAT_ENDPOINT_V2,
    headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${REVENUECAT_API_KEY_V2}`,
        'X-Platform': 'stripe',
    }
});
const syncSubscriptionChanges = (userId, subscriptionToken) => {
    try {
        revenueCatNetworkV1.post('receipts', {
            app_user_id: userId,
            fetch_token: subscriptionToken,
        }, {
            headers: {
                'X-Platform': 'stripe',
            }
        });
    }
    catch (error) {
        throw error;
    }
};
exports.syncSubscriptionChanges = syncSubscriptionChanges;
const getUserInfo = (userId) => {
    try {
        return (revenueCatNetworkV1.get(`subscribers/${userId}`)
            .then((response) => response.data));
    }
    catch (error) {
        throw error;
    }
};
exports.getUserInfo = getUserInfo;
const getProduct = (productId) => {
    try {
        return (revenueCatNetworkV2.get(`projects/${REVENUECAT_PROJECT_ID}/products/${productId}`)
            .then((response) => response.data));
    }
    catch (error) {
        throw error;
    }
};
exports.getProduct = getProduct;
const getAllProducts = () => {
    try {
        return (revenueCatNetworkV2.get(`projects/${REVENUECAT_PROJECT_ID}/products`)
            .then((response) => response.data));
    }
    catch (error) {
        throw error;
    }
};
exports.getAllProducts = getAllProducts;
